import { loadStripe } from '@stripe/stripe-js';
import { CountryCode } from '@whoop/i18n';
import { env } from 'env';

const triesLeft: Record<string, number> = {
  [env.NEXT_PUBLIC_STRIPE_KEY]: 3,
  [env.NEXT_PUBLIC_STRIPE_EU_KEY]: 3,
};

export const stripeCatchAndTryAgain = async (key: string) => {
  if (triesLeft[key] === 0) {
    return null;
  }
  try {
    const stripe = await loadStripe(key);
    return stripe;
  } catch (error) {
    const retry = await stripeCatchAndTryAgain(key);
    return retry;
  } finally {
    triesLeft[key] -= 1;
  }
};

export const getStripeAccount = (country: CountryCode) => {
  switch (country) {
    // AU + NZ
    case 'NZ':
    case 'AU':
    // GCC
    case 'QA':
    case 'AE':
    case 'SA':
    // EU
    case 'AX':
    case 'AT':
    case 'BE':
    case 'BG':
    case 'HR':
    case 'CY':
    case 'CZ':
    case 'DK':
    case 'EE':
    case 'FO':
    case 'FI':
    case 'FR':
    case 'DE':
    case 'GR':
    case 'GL':
    case 'HU':
    case 'IS':
    case 'IE':
    case 'IT':
    case 'LV':
    case 'LT':
    case 'LU':
    case 'MT':
    case 'MC':
    case 'NL':
    case 'NO':
    case 'PL':
    case 'PT':
    case 'RO':
    case 'SK':
    case 'SI':
    case 'ES':
    case 'SE':
    case 'CH':
    // UK
    case 'GB':
    // ROW
    case 'BH':
    case 'HK':
    case 'IL':
    case 'JP':
    case 'KR':
    case 'KW':
    case 'SG':
    case 'TW':
    case 'ZA':
    case 'IN':
    case 'MX':
      return 'EU';
    default: // US, CA, Invalid countries
      return 'US';
  }
};
